// extracted by mini-css-extract-plugin
export default {"description":"LanguageSelection_description__IcMlJ"};